/* Progressive search; native details and topic links also work without JavaScript. */
(() => {
  const root = document.querySelector('[data-sf-page]');
  if (!root || root.dataset.sfReady) return;
  const form = root.querySelector('[data-sf-search]');
  const input = root.querySelector('[data-sf-input]');
  if (!form || !input) return;
  root.dataset.sfReady = 'true';
  const questions = [...root.querySelectorAll('[data-sf-question]')];
  const groups = [...root.querySelectorAll('[data-sf-group]')];
  const results = root.querySelector('[data-sf-results]');
  const empty = root.querySelector('[data-sf-empty]');
  const normalize = value => value.toLocaleLowerCase().normalize('NFKD').replace(/[\u0300-\u036f]/g, '').replace(/[^\p{L}\p{N}]+/gu, ' ').trim();
  const searchText = new Map(questions.map(item => [item, normalize(item.textContent)]));
  let previousOpen = null;
  function filter() {
    const query = normalize(input.value);
    const words = query.split(/\s+/).filter(Boolean);
    if (query && !previousOpen) previousOpen = new Set(questions.filter(item => item.open));
    let count = 0;
    questions.forEach(item => {
      const matches = words.every(word => searchText.get(item).includes(word));
      item.hidden = !matches;
      if (matches) count++;
      if (query) item.open = matches;
      else if (previousOpen) item.open = previousOpen.has(item);
    });
    if (!query) previousOpen = null;
    groups.forEach(group => { group.hidden = ![...group.querySelectorAll('[data-sf-question]')].some(item => !item.hidden); });
    empty.hidden = count !== 0;
    results.hidden = !query;
    results.textContent = query ? root.dataset.sfResultsLabel.replace('[count]', String(count)) : '';
  }
  form.hidden = false;
  input.addEventListener('input', filter);
  input.addEventListener('search', filter);
  form.addEventListener('submit', event => { event.preventDefault(); filter(); });
  root.querySelectorAll('[data-sf-topic]').forEach(link => {
    link.addEventListener('click', event => {
      const group = groups.find(item => item.dataset.sfGroup === link.dataset.sfTopic);
      if (!group) return;
      event.preventDefault();
      input.value = '';
      filter();
      group.querySelector('.sf__group-heading').focus({ preventScroll: true });
      group.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth', block: 'start' });
    });
  });
})();
